<template>
  <div>
    <public-table :table="tableData"></public-table>
  </div>
</template>

<script>
  import publicTable from '@/components/publicTable'
  export default {
    components:{
      publicTable
    },
    props:{
    },
    data() {
      return {
        tableData: {
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,		// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	hasShowPagination: false,	// 是否显示分页
        	config: [
            {
              label: '日期',
              value: 'date',
              show: 'normal',
            },
            {
              label: '实际收入',
              value: 'actualDebitMoney',
              show: 'normal',
            },
            {
              label: '实际支出',
              value: 'actualCreditorMoney',
              show: 'normal',
            },
            {
              label: '实际余额',
              value: 'actualRemainingSum',
              show: 'normal',
            },
            {
              label: '差额原因',
              value: 'differenceReason',
              show: 'normal',
            },
            {
              label: '盘点人',
              value: 'inventoryUser',
              show: 'normal',
            }
          ],
        	data: [],
        	page: {
        		pageNo: 1,
        		pageSize: 10,
        		count: 0
        	},
        	center: {
        		textAlign: 'center',
        		padding: '6px 0'
        	},
        },
      }
    },
    computed:{

    },
    methods:{
      getTable(row) {
        let params = {
           fkJournalAccountId: row.fkJournalAccountId,
           date:  row.date
         }
        this.tableData.loading = true;
         this.$http.post('journal/getUpdateActualBookAmount',params).then(res=>{
            this.tableData.loading = false;
            if(res && res.data.code == 1) {
               this.tableData.data = res.data.data;
            }
         })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/inventory/editTable.vue